import { useEffect, useState } from "react";

/** Minimal hash router. `#/` = overview, `#/app/<id>` = detail. */
export function useRoute(): { name: "overview" | "app"; id?: string } {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const on = () => setHash(window.location.hash);
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  const m = /^#\/app\/(.+)$/.exec(hash);
  return m ? { name: "app", id: decodeURIComponent(m[1]!) } : { name: "overview" };
}

export const navigate = (to: string) => { window.location.hash = to; };
export const openApp = (id: string) => navigate(`/app/${encodeURIComponent(id)}`);
export const goHome = () => navigate("/");
